import React, { useEffect, useState } from 'react';
import parse from "html-react-parser";
import YTPlayer from "../youtubePlayer/YTPlayer";

import backArrow from '../../assets/images/back.svg';
import mi_multekoloras from '../../assets/audio/mi_multekoloras.mp3';


const audios = {
  mi_multekoloras
}
const opts = {
  width: '640',
  playerVars: {
    controls:1,
    playsinline:1,
    modestbranding:1,
    autohide:0,
    showinfo:0,
    rel:0,
    showsearch:0,
    fs:0,
    disablekb:1,
    enablejsapi:1,
    webkitPlaysinline:1,
    iv_load_policy:1
    },
};

const AuthorWrapper = (p) => {
  const [action, store] = [p.action, p.store];
  const [lang] = useState("esp");
  useEffect( ()=> {
  },[store.currentText])


  const selectItem = (index) => {
    action('UPDATE_CURRENT_TEXT', index);
  }

  const getContentSidebarClass = () => {
    return (
      "content-sidebar" + (store.currentText !== null ? ' selected' : '')
    )
  }
  const getSidebarItemClass = (index) => {
    return "sidebar-item" + ( index === store.currentText ? ' selected' : '' );
  }
  const getArticlesList = () => {
    if (!p.itemlist) { return null }
      return (
        p.itemlist.map((item, index) => (
          <li className={getSidebarItemClass(index)} key={index} onClick={()=>selectItem(index)}>
              {item[lang].itemName}
          </li>
        ))
      )
  }
  const prevArticle = () => {
    if (store.currentText === 0) {return;}
    selectItem(store.currentText-1)
  }
  const nextArticle = () => {
    if (store.currentText === p.itemlist.length-1) {return;}
    selectItem(store.currentText+1)
  }
  const getItemContent = () => {
    const article = store.currentText === null ? null : p.itemlist[store.currentText][lang];

    return ( !article ? 
      null : 
      <div>
        <div className="flex flex-spread flex-v-center mb-3 mt-3">
          <button 
            disabled={store.currentText === 0} 
            className="button button-back" 
            onClick={()=>prevArticle()}>Antaŭa</button>
          <button 
            disabled={store.currentText === p.itemlist.length-1} 
            className="button button-next" 
            onClick={()=>nextArticle()}>Sekva</button>
        </div>
        <h2 className="text-center">{article.itemName}</h2>
        {articleTranslator(article)}
        <div className="article-content-item">
          {parse(article.itemContent)}
        </div>
        {articleAuthor(article)}
        {articleDate(article)}
        {articlePlace(article)}
        {articleVideo(article)}
        {articleAudio(article)}
      </div>
    )
  }
  const articleAuthor = (article) => {
    return !article.itemAuthor ? null : <p className="article-author"><span>{ parse (article.itemAuthor) }</span></p>
  }
  const articleTranslator = (article) => {
    return !article.itemTranslator ? null : <p className="article-translator"><span>{ parse (article.itemTranslator) }</span></p>
  }
  const articleDate = (article) => {
    return !article.itemDate ? null : <p className="article-date"><span>{article.itemDate}</span></p>
  }
  const articlePlace = (article) => {
    return !article.itemPlace ? null : <p className="article-place"><span>{article.itemPlace}</span></p>
  }

  const getFacebookVideo = (i) => {
    return (
      <iframe 
        key={i}
        title={i}
        src={getSrc(i)}
        width="640"
        height="360"
        style={{'border':'none','overflow':'hidden', 'margin': '0 auto'}} 
        scrolling="no" 
        frameborder="0" 
        allowfullscreen="true" 
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" 
        allowFullScreen="true">
      </iframe>
    )
  }
  const getSrc = (i) => {
    return (
      "https://www.facebook.com/plugins/video.php?" + 
      `href=https%3A%2F%2Fwww.facebook.com%2FValeshkovsky.Konstantin%2Fvideos%2F${i.split('facebook')[1]}` + 
      "&width=640" + 
      "&show_text=false" + 
      "&appId" 

    )
  }

  const getParsedYoutubeVideo = (i) => {
    let [id, start, end] = i.split('&');
    opts.playerVars.start = +(start.split('start=')[1]);
    opts.playerVars.end = +(end.split('end=')[1]);
    return <YTPlayer key={i} videoid={id} opts={opts} ></YTPlayer> 
  }

  const articleAudio = (article) => {
    return !article.itemAudio ? null : (
      article.itemAudio.map(i => 
        <div className="article-audio d-flex flex-center">
          <audio controls>
            <source src={audios[i]} type="audio/mpeg" />
            Your browser does not support the audio tag.
          </audio>
        </div>
      )
    )
  }
  const articleVideo = (article) => {
    return !article.itemVideo ? null : (
      <div className="flex flex-center flex-column text-center auto-resizable-iframe">
        {article.itemVideo.map(i => 
        (i.includes('facebook') ? 
          getFacebookVideo(i) :
          ( i.includes('&start') ? 
            getParsedYoutubeVideo(i) :
            <YTPlayer key={i} videoid={i} opts={opts} ></YTPlayer> 
          ))
        )}
      </div>
    )
  }
  return (
    <div className="flex col">
      <div className={getContentSidebarClass()}>
        <div className="flipping-card">
          <div className="front face">
            <div className="fabeloj-list">
              {getArticlesList()}
            </div>
          </div>
          <div className="back face">
            <div className="back-button" onClick={()=>selectItem(null)}>
              <img src={backArrow} alt="Back" />
            </div> 
          </div>
        </div>
      </div>
      <div className="content-main col">
        {getItemContent()}
      </div>
    </div>
  )
}

export default AuthorWrapper;